<template>
    	<div class="profile-sidebar notmobile_menu">
            <div class="widget-profile pro-widget-content">
                <div class="profile-info-widget">
                    <a href="#" class="booking-doc-img">
                        <img src="@/assets/img/user2.jpg" alt="User Image">
                    </a>
                    <div class="profile-det-info">
                        <h3>{{user.namauser}}</h3>
                        <div class="receiver-details">
                            <h5>{{(user.hak_akses == '1')?"Siswa":((user.hak_akses == '1')?"Mitra":"-")}}</h5>
                            <!-- <h5 class="mb-0"><i class="fas fa-map-marker-alt"></i> Newyork, USA</h5> -->
                        </div>
                    </div>
                </div>
            </div>
            <div class="dashboard-widget">
                <nav class="dashboard-menu">
                    <ul>
                        
                    <template v-if="user.hak_akses == '1' || user.hak_akses == '4'">
                        <li v-bind:class="{'active': currentPath == 'siswa-profile-settings'}">
                            <router-link to="/siswa/profile-settings">
                                <i class="fas fa-user-cog"></i>
                                <span>Identitas Diri</span>
                            </router-link>
                        </li>
                        <!-- <li v-bind:class="{'active': currentPath == 'siswa-instansi'}">
                            <router-link to="/siswa/instansi">
                                <i class="fas fa-building"></i>
                                <span>Sekolah</span>
                            </router-link>
                        </li> -->
                        <!-- <li v-bind:class="{'active': currentPath == 'siswa-rekam-jejak'}">
                            <router-link to="/siswa/rekam-jejak">
                                <i class="fas fa-history"></i>
                                <span>Keuangan</span>
                            </router-link>
                        </li> -->
                        <li v-bind:class="{'active': currentPath == 'mitra-penjualan'}" v-if="user.hak_akses == '4'">
                            <router-link to="/mitra/penjualan">
                                <i class="fas fa-columns"></i>
                                <span>Penjualan</span>
                            </router-link>
                        </li>
                        <li v-bind:class="{'active': currentPath == 'siswa-paket-belajar'}">
                            <router-link to="/index">
                                <i class="fas fa-calendar-check"></i>
                                <span>Paket Belajar</span>
                                <small class="unread-msg">{{cntPaket}}</small>
                            </router-link>
                        </li> 
                        <li v-bind:class="{'active': currentPath == 'siswa-transaksi'}">
                            <router-link to="/siswa/transaksi">
                                <i class="fas fa-calendar-check"></i>
                                <span>Transaksi</span>
                            </router-link>
                        </li> 
                        <li v-bind:class="{'active': currentPath == 'siswa-paket-saya'}">
                            <router-link to="/siswa/paket-saya">
                                <i class="fas fa-calendar-check"></i>
                                <span>Paket Saya</span>
                                <small class="unread-msg">{{cntPaketSaya}}</small>
                            </router-link>
                        </li> 
                        <li v-bind:class="{'active': currentPath == 'siswa-learndoteach'}">
                            <router-link to="/siswa/learndoteach">
                                <i class="fas fa-columns"></i>
                                <span>#LearnDoTeach</span>
                                <small  class="unread-msg badge badge-pill bg-primary-light p-2">NEW</small>                                
                            </router-link>
                        </li>
                        <li v-bind:class="{'active': currentPath == 'siswa-wallet'}">
                            <router-link to="/siswa/wallet">
                                <i class="fas fa-comments"></i>
                                <span>Komisi</span>
                                <small  class="unread-msg badge badge-pill bg-primary-light p-2">NEW</small>                                                               
                            </router-link>
                        </li>
                        <li>
                            
                            <a @click="logout">
                                <i class="fas fa-sign-out-alt"></i>
                                <span>Keluar</span>
                            </a>
                        </li>
                    </template>
                    
                    </ul>
                </nav>
            </div>
            <div class="widget-profile pro-widget-content">
                <div class="profile-info-widget">
                    <a href="https://wa.me/+6285183033543" target="_blank" class="booking-doc-img  bg-white">
                        <img src="@/assets/img/cs2.jpg" alt="User Image">
                    </a>
                    <div class="profile-det-info">
                        <p>Anda mengalami kesulitan? <br>silahkan klik tombol berikut</p>
                        <div class="receiver-details">
                            <a href="https://wa.me/+6285183033543" target="_blank" class="btn btn-sm bg-warning">
                                 Hubungi Kami
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
</template>

<script>
import Util from '../../../assets/utils/utils'
import {mapGetters} from 'vuex'
import store from '../../../store'
import axios from 'axios';

export default {
    
    data() {
        return {
            cntPaket: 0, cntPaketSaya: 0,
        }
    },
    created: function () {
        
        if(localStorage.getItem('token')){
            store.dispatch("checktoken");
        }
        this.getCntPaket();
        this.getCntPaketSaya();
    },
    methods: {
        logout: function() {
            this.$store.dispatch("logout").then(() => {
                this.$router.push("/login");
            });
        },
        getCntPaket: function () {
            axios.get('api/cntpaket')
                .then(res => {
                    this.cntPaket = res.data.data;
                })
                .catch(err => {
                    // handle error
                    console.log(err);
                })
        },
        getCntPaketSaya: function () {
            axios.get('api/cntpaketsaya/'+localStorage.getItem('idUser'))
                .then(res => {
                    this.cntPaketSaya = res.data.data;
                })
                .catch(err => {
                    // handle error
                    console.log(err);
                })
        },
    },
    computed: {
        ...mapGetters({ 
            isLoggedIn: 'isLoggedIn',
            user: 'user',
        }),
        currentPath() {
            return this.$route.name
        }
    },
    // methods: { 
    //     scrollToTop() {
    //         window.scrollTo(0,0);
    //     }
    // }
}
</script>


// WEBPACK FOOTER //
// src/components/Siswa/Sidebar/index.vue